import React from 'react';
import AccordionV2 from '../../../AccordionV2';
import { LinkV2 } from '../../../LinkV2';
import {
  AccordionWrapper,
  ContentWrapper,
  FooterWrapper,
  LeftRailWrapper,
  LinksWrapper,
  StyledH5,
  StyledHr,
  StyledLi,
} from './BabyFooter.styles';
import Terms from './Terms';
import ZolaInfo from './ZolaInfo';

const ABOUT: FooterSectionProps = {
  links: [
    {
      href: 'https://www.zola.com',
      linkText: 'Zola weddings',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    {
      href: 'https://www.zola.com/about/team',
      linkText: 'Careers',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  ],
};

const SUPPORT1: FooterSectionProps = {
  links: [
    { href: '/search/baby-registry', linkText: 'Find a baby registry' },
    { href: '/order-status', linkText: 'Track order', target: '_self' },
    { href: '/order-status', linkText: 'Start a return', target: '_self' },
  ],
};

const SUPPORT2: FooterSectionProps = {
  links: [
    { href: '/returns', linkText: 'Return policy' },
    { href: '/contact-us', linkText: 'Contact us' },
    { href: '/faq', linkText: 'FAQs' },
  ],
};

type FooterSectionProps = {
  links: {
    href: string;
    linkText: string;
    target?: string;
    rel?: string;
  }[];
};

const FooterSection = (props: FooterSectionProps) => {
  const { links } = props;
  return (
    <ul>
      {links.map((link) => {
        const { href, linkText, target, rel } = link;
        return (
          <StyledLi key={`footer-link-${linkText}`}>
            <LinkV2 href={href} subtle noUnderline target={target} rel={rel} noTextTransform>
              {linkText}
            </LinkV2>
          </StyledLi>
        );
      })}
    </ul>
  );
};

const renderMobileFooterSection = () => {
  const items = [
    {
      hed: 'Support',
      dek: <FooterSection links={[...SUPPORT1.links, ...SUPPORT2.links]} />,
      id: 1,
    },
    {
      hed: 'About',
      dek: <FooterSection {...ABOUT} />,
      id: 2,
    },
  ];
  return (
    <AccordionWrapper>
      <AccordionV2 items={items} initialExpandedItems={1} arrowOnLeft={false} />
    </AccordionWrapper>
  );
};

const BabyFooter = (): JSX.Element => {
  return (
    <FooterWrapper>
      <ContentWrapper>
        <LinksWrapper>
          {renderMobileFooterSection()}
          <LeftRailWrapper>
            <div>
              <StyledH5>About</StyledH5>
              <FooterSection {...ABOUT} />
            </div>
            <div>
              <StyledH5>Support</StyledH5>
              <FooterSection {...SUPPORT1} />
            </div>
            <div>
              <StyledH5>&nbsp;</StyledH5>
              <FooterSection {...SUPPORT2} />
            </div>
          </LeftRailWrapper>
          <StyledHr />
          <ZolaInfo />
        </LinksWrapper>
      </ContentWrapper>
      <Terms />
    </FooterWrapper>
  );
};

export default BabyFooter;
